import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

type SelectOption = {
  value: string
  label: string
}

interface LanguageSelectorProps {
  label?: string
}

export const LanguageSelector = ({ label }: LanguageSelectorProps) => {
  const { i18n } = useTranslation()

  const options = [
    {
      value: 'en',
      label: 'English',
    },
    { value: 'it', label: 'Italiano' },
  ]

  const onChange = (v: SelectOption | null) => {
    if (v) {
      i18n.changeLanguage(v.value)
    }
  }

  return (
    <AdvancedSelect<SelectOption>
      value={options.find((filter) => filter.value === i18n.language)}
      label={label}
      name="language"
      id="language"
      options={options}
      onChange={onChange}
    />
  )
}
